import { render, staticRenderFns } from "./electric-bill-pay.vue?vue&type=template&id=1205c228&scoped=true&"
import script from "./electric-bill-pay.vue?vue&type=script&lang=js&"
export * from "./electric-bill-pay.vue?vue&type=script&lang=js&"
import style0 from "./electric-bill-pay.vue?vue&type=style&index=0&id=1205c228&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1205c228",
  null
  
)

export default component.exports